"use client";

import { useState, useEffect } from "react";

interface TimerProps {
    duration?: number; // Seconds
    onTimerUpdate?: (currentTime: number) => void;
}

export const CountdownTimer: React.FC<TimerProps> = ({ duration = 60, onTimerUpdate }) => {
    const [time, setTime] = useState(duration);

    useEffect(() => {
        let interval: any = null;
        if (time > 0) {
            interval = setInterval(() => {
                setTime((prevTime) => prevTime - 1);
            }, 1000);
        }
        if (onTimerUpdate) onTimerUpdate(time);

        return () => {
            clearInterval(interval);
        };
    }, [time, onTimerUpdate]);

    const formatTime = (seconds: number) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;

        return `${minutes.toString().padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
    };

    return <>{formatTime(time)}</>;
};
